var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareBlack24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.56C12.93 13.56 12.42 13.785 12.03 14.1375L6.6825 11.025C6.72 10.8525 6.75 10.68 6.75 10.5C6.75 10.32 6.72 10.1475 6.6825 9.975L11.97 6.8925C12.375 7.2675 12.9075 7.5 13.5 7.5C14.745 7.5 15.75 6.495 15.75 5.25C15.75 4.005 14.745 3 13.5 3C12.255 3 11.25 4.005 11.25 5.25C11.25 5.43 11.28 5.6025 11.3175 5.775L6.03 8.8575C5.625 8.4825 5.0925 8.25 4.5 8.25C3.255 8.25 2.25 9.255 2.25 10.5C2.25 11.745 3.255 12.75 4.5 12.75C5.0925 12.75 5.625 12.5175 6.03 12.1425L11.37 15.2625C11.3325 15.42 11.31 15.585 11.31 15.75C11.31 16.9575 12.2925 17.94 13.5 17.94C14.7075 17.94 15.69 16.9575 15.69 15.75C15.69 14.5425 14.7075 13.56 13.5 13.56ZM13.5 4.5C13.9125 4.5 14.25 4.8375 14.25 5.25C14.25 5.6625 13.9125 6 13.5 6C13.0875 6 12.75 5.6625 12.75 5.25C12.75 4.8375 13.0875 4.5 13.5 4.5ZM4.5 11.25C4.0875 11.25 3.75 10.9125 3.75 10.5C3.75 10.0875 4.0875 9.75 4.5 9.75C4.9125 9.75 5.25 10.0875 5.25 10.5C5.25 10.9125 4.9125 11.25 4.5 11.25ZM13.5 16.515C13.0875 16.515 12.75 16.1775 12.75 15.765C12.75 15.3525 13.0875 15.015 13.5 15.015C13.9125 15.015 14.25 15.3525 14.25 15.765C14.25 16.1775 13.9125 16.515 13.5 16.515Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.75V2.25H5.75V0H4.25V2.25H2V3.75H4.25V6H5.75V3.75H8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBlack24Dp);
export default __webpack_public_path__ + "static/media/share_black_24dp.675c2a5c05f1e0f08cd9a86bec6e2e8f.svg";
export { ForwardRef as ReactComponent };